<ion-content class="savings-content">
  <div class="savings-container" (click)="onOutsideClick($event)">
    <div class="savings-card" (click)="$event.stopPropagation()">
      <!-- 3D Gift Box illustration -->
      <div class="gift-illustration">
        <img src="https://img.travelx.ai/bfl/3d-gift.png" alt="Congratulations Gift" class="gift-image">
      </div>
      
      <!-- Congratulations message -->
      <div class="congratulations-message">
        <h2 class="congratulations-title">Congratulations!</h2>
        <p class="savings-text">You saved <span class="savings-amount">{{currency}}{{savingsAmount}}</span> on your booking</p>
      </div>
      
      <!-- Action buttons -->
      <!-- <div class="action-section">
        <button class="continue-btn" (click)="onContinue()">
          <span class="btn-text">Continue</span>
          <ion-icon name="arrow-forward" class="arrow-icon"></ion-icon>
        </button>
      </div> -->
    </div>
  </div>
</ion-content>
